import clsx from 'clsx'
import { Button, CreateTableState, Grid, Icon, Spinner, Tooltip, Typography } from 'gu-ui-kit'
import React, { useEffect, useState } from 'react'
import styles from 'modules/Agency/agency.module.scss'
import { parseISO } from 'date-fns'
import format from 'utils/dateFns/format'
import StatusBadge from 'modules/Agency/Requests/subcomponents/StatusBadge'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

export const useTableConfig = ({ deleteRequest = () => {}, ...rest }, data = []) => {
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()

  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    switch (true) {
      case breakpoints.sm:
        setColumnVisibility({ created_at: false, status: false })
        break
      case breakpoints.fb:
        setColumnVisibility({ status: false })
        break
      default:
        setColumnVisibility({})
        break
    }
  }, [breakpoints])

  const tableConfig = {
    getSubRows: (row) => row.subRows,
    className: styles['requests-list'],
    columns: [
      {
        id: 'name',
        header: t('agency::list.headers.name', {
          context: breakpoints.xs ? 'with_status_date' : breakpoints.fb ? 'with_status' : '',
        }),

        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              name,
              user_id,
              created_at,
              status,
            },
          },
        }) => (
          <Grid wrap={'nowrap'} justifyContent="start" alignItems="center">
            <Grid
              className={clsx(
                styles['requests-list__recommendation'],
                styles['requests-list__col-name'],
              )}
              fluid={false}
              direction="column"
              alignItems="start"
              justifyContent="start"
            >
              <Typography variant={'Body-15'} noMargin className={styles['client__name']}>
                {name}
              </Typography>
              <Typography
                variant={'Body-10'}
                noMargin
                color={'Label-Secondary'}
                className={styles['client__email']}
              >
                ID: {user_id}
              </Typography>

              {breakpoints.xs && (
                <Typography noMargin variant={'Body-10'} className={styles['client__date_small']}>
                  {format(parseISO(created_at, "yyyy-MM-dd'T'HH:mm:ssXXX"), 'd MMMM yyyy')}
                </Typography>
              )}
              {breakpoints.fb && <StatusBadge status={status} />}
            </Grid>
          </Grid>
        ),
      },
      {
        id: 'status',
        header: t('agency::list.headers.status'),
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              status, // eslint-disable-next-line react/prop-types
            },
          },
        }) => (
          <Grid
            alignItems="start"
            justifyContent="start"
            direction="column"
            l={{
              direction: 'row',
              alignItems: 'center',
              justifyContent: 'between',
            }}
          >
            <StatusBadge status={status} />
          </Grid>
        ),
      },
      {
        id: 'created_at',
        header: t('agency::list.headers.date'),

        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              created_at,
            },
          },
        }) => (
          // eslint-disable-next-line react/prop-types
          <Typography className={styles['requests-list__col-balance']} variant={'Body-15'} noMargin>
            {format(parseISO(created_at, "yyyy-MM-dd'T'HH:mm:ssXXX"), 'd MMMM yyyy')}
          </Typography>
        ),
      },
      {
        id: 'actions',
        header: ' ',
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              processing,
              // eslint-disable-next-line react/prop-types
              id,
            },
          },
        }) => (
          <Grid
            alignItems="flex-end"
            justifyContent="flex-end"
            className={styles['requests-list__col-actions']}
          >
            <Tooltip title={t('agency::list.extra_actions.delete')}>
              {processing ? (
                <Spinner width={24} />
              ) : (
                <Button
                  noLabel
                  startIcon={<Icon name={'close'} />}
                  color={'Interface-Seventh'}
                  size={'m'}
                  onClick={() => deleteRequest(id)}
                />
              )}
            </Tooltip>
          </Grid>
        ),
      },
    ],
    state: {
      columnVisibility,
    },
    ...rest,
  }

  return {
    tableState: CreateTableState(tableConfig, data),
    tableConfig,
  }
}
